import React, { useState } from "react";
import styled from "styled-components";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { Navigation2 } from "../components/Navigation";
import { account, ID } from "../lib/appwrite";
import { addUser, getAllUsers } from "../lib/actions";
import { Query } from "appwrite";
import { LoaderIcon } from "../components/svg/Icons";

const Section = styled.section`
  min-height: ${(props) => `calc(100vh - ${props.theme.navHeight})`};
  width: 100vw;
  position: relative;
  background-color: ${(props) => props.theme.body};
`;

const Container = styled.div`
  width: 75%;
  min-height: 80vh;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
  }
`;

const FormContainer = styled.form`
  width: 100%;
  max-width: 600px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;

  @media (max-width: 64em) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 48em) {
    width: 80%;
    margin: 1rem auto;
    grid-template-columns: repeat(1, 1fr);
  }
`;

const InputBox = styled.input`
  padding: 0.8rem;
  border-radius: 0.5rem;
  border: 1px solid ${(props) => props.theme.text};
  background-color: transparent;
  color: ${(props) => props.theme.text};
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.primary};
  }
`;

const SubmitButton = styled.button`
  grid-column: span 2;
  padding: 0.8rem 2rem;
  font-size: 1rem;
  border-radius: 2rem;
  border: none;
  cursor: pointer;
  background-color: ${(props) => props.theme.text};
  color: ${(props) => props.theme.body};
  transition: all 0.3s ease;

  &:hover {
    background-color: ${(props) => props.theme.primary};
  }

  @media (max-width: 48em) {
    grid-column: span 1;
  }
`;

const Signup = () => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    wallet_address: "",
  });
  console.log(formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { firstName, lastName, email, password, confirmPassword } = formData;

    if (!firstName || !lastName || !email || !password || !confirmPassword) {
      return toast.error("All fields are required.");
    }

    if (password !== confirmPassword) {
      return toast.error("Passwords do not match.");
    }

    setLoading(true);

    try {
      // Replace with actual signup logic
      await register({
        firstname: firstName,
        lastname: lastName,
        email,
        password,
      });
    } catch (error) {
      console.error(error);
      toast.error("Signup failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  async function register({ firstname, lastname, email, password }) {
    try {
      const create_account = await account.create(
        ID.unique(),
        email,
        password,
        firstname + " " + lastname
      );
      
      // const exists = await getUserByDocument(create_account.$id);
      console.log(formData.userName)
      const usernameExists = await getAllUsers([
        Query.equal("username", [formData.userName])
      ]);
      console.log(usernameExists);

      if (usernameExists.length === 0) {
        console.log(">>>>>>>>> Working 2");
        console.log(formData);

        const new_user = await addUser({
          username: formData.userName,
          userId: create_account.$id,
          email: create_account.email,
          name: create_account.name,
          wallet_address: formData.wallet_address || "",
        });

        console.log("New user added:", new_user);
      }
      navigate("/login");
      toast.success("Signup successful! Please login.");
    } catch (error) {
      console.error("Signup failed:", error);
      if (error.code === 409) {
        toast.error("User already exists with this email.");
      } else if (error.code === 422) {
        toast.error("Invalid email format.");
      } else {
        toast.error("Signup failed. Please try again.");
      }
    }
  }

  const renderButtonContent = () => {
    if (isLoading) {
      console.log("Loading...");
      return <LoaderIcon width={20} height={20} color="white" />;
    }

    return "Register";
  };

  return (
    <Section id="Signup">
      <Navigation2 />
      <Container>
        <FormContainer onSubmit={handleSubmit}>
          <InputBox
            type="text"
            name="userName"
            placeholder="username"
            required
            value={formData.userName}
            onChange={handleChange}
          />
          <InputBox
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
          />
          <InputBox
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
          />
          <InputBox
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
          />
          <InputBox
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
          />
          <InputBox
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={handleChange}
          />
          <InputBox
            type="text"
            name="wallet_address"
            placeholder="Wallet Address"
            value={formData.wallet_address}
            onChange={handleChange}
          />
          <SubmitButton type="submit" disabled={isLoading}>
            {renderButtonContent()}
          </SubmitButton>

          <p style={{ textAlign: "center", marginTop: "1rem", width: "100%" }}>
            Already have an account?{" "}
            <a href="/login" style={{ color: "blue", cursor: "pointer" }}>
              login
            </a>
          </p>
        </FormContainer>
      </Container>
    </Section>
  );
};

export default Signup;
